import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BookOpen, Users, ShoppingBag, MessageSquare, Sparkles, Award, DollarSign, FileText } from "lucide-react";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-6" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="w-10 h-10 rounded-2xl bg-brand-pink/20 flex items-center justify-center mb-4">
        <Icon className="w-5 h-5 text-brand-pink" />
      </div>
      <div className="font-display text-3xl">{value}</div>
      <div className="text-xs uppercase tracking-widest text-white/50 mt-1">{label}</div>
    </div>
  );
}

export default function AdminOverview() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="text-white/50">Loading overview…</div>;

  return (
    <div>
      <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">Overview</div>
      <h1 className="font-display text-4xl mb-2">Welcome back, Kristy.</h1>
      <p className="text-white/60 mb-10">Everything Host Hustle at a glance.</p>

      <div className="grid md:grid-cols-4 gap-4">
        <Stat icon={DollarSign} label="Revenue" value={`$${stats.revenue.toLocaleString()}`} />
        <Stat icon={ShoppingBag} label="Orders" value={stats.orders_total} />
        <Stat icon={Users} label="Users" value={stats.users_total} />
        <Stat icon={BookOpen} label="Courses" value={stats.courses_total} />
        <Stat icon={ShoppingBag} label="Products" value={stats.products_total} />
        <Stat icon={MessageSquare} label="Community Posts" value={stats.community_posts} />
        <Stat icon={FileText} label="Blog Posts" value={stats.blog_posts} />
        <Stat icon={Sparkles} label="AI Generations" value={stats.ai_generations} />
      </div>

      <div className="mt-10 rounded-3xl bg-white/5 border border-white/10 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Award className="w-4 h-4 text-brand-pink" />
          <div className="font-display text-xl">Certificates issued</div>
          <div className="ml-auto text-brand-pink font-display text-2xl">{stats.certificates_issued}</div>
        </div>
      </div>

      <div className="mt-6 rounded-3xl bg-white/5 border border-white/10 p-6">
        <div className="font-display text-xl mb-4">Latest orders</div>
        {stats.latest_orders?.length ? (
          <div className="divide-y divide-white/5">
            {stats.latest_orders.map((o) => (
              <div key={o.id} className="flex items-center justify-between py-3 text-sm">
                <div>
                  <div className="text-white">{o.product_name}</div>
                  <div className="text-white/50 text-xs">{o.user_email} · {new Date(o.created_at).toLocaleString()}</div>
                </div>
                <div className="text-brand-pink font-display text-lg">${o.amount}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-white/50 text-sm">No orders yet.</div>
        )}
      </div>
    </div>
  );
}
